import ReactTableBase from "../../Table/ReactTableBase";
import React from "react";
import {Link} from "react-router-dom";
import styles from "../../Table/ReactTableBase.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit, faExternalLink} from "@fortawesome/free-solid-svg-icons";
import RenderCellActif from "../../Table/RenderCellActif";
import RenderCellSplit from "../../Table/RenderCellSplit";
import {useModal} from "../../../contexts/ModalContext";
import AxiosConfig from "../../../services/AxiosConfig";
import RenderCellLogo from "../../Table/RenderCellLogo";
import Routing from "../../../services/routing";


const ActiviteTypeTable = ({ activiteTypes, putActifOpenModal = null, setImage = null  }) => {
    const data = React.useMemo(() => activiteTypes, [activiteTypes]);
    const {showModal, hideModal} = useModal();

    const handleSuccess = (children = "Enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 5000});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 5000});
    };

    const renderCellId = ({ row, value }) => {
        return <Link to={Routing.generate({ route: Routing.routes.adminActiviteType, params: { activiteTypeId: value } })}>{value}</Link>;
    }

    const renderCellLabel = ({ row, value }) => {
        return <Link to={Routing.generate({ route: Routing.routes.adminActiviteType, params: { activiteTypeId: row.original.actId } })}>
            {RenderCellSplit({ value: value })}
        </Link>;
    }

    const renderCellDescription = ({ row, value }) => {
        return RenderCellSplit({ value: value });
    }


    const renderCellActions = ({ row, value }) => {
        return (
            <div className={styles.actions}>
                <Link to={Routing.generate({ route: Routing.routes.adminActiviteType, params: { activiteTypeId: row.original.actId } })}>
                    <FontAwesomeIcon icon={faExternalLink}/>
                    Détail
                </Link>

                <Link to={Routing.generate({ route: Routing.routes.adminActiviteType, params: { activiteTypeId: row.original.actId }, queryParams: {mode: "creation"} })}>
                    <FontAwesomeIcon icon={faEdit}/>
                    Modifier
                </Link>
            </div>
        );
    }

    const renderCellColors = ({ row, value }) => {
        return (
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                <div style={{ backgroundColor: value, padding: "10px"}}></div>
                <div style={{ backgroundColor: row.original.actColorBkg, padding: "10px" }}></div>
            </div>
        );
    }

    const handleSubmitLogo = async (values, {setSubmitting, resetForm, setErrors, row}) => {
        if (values.file) {
            const formData = new FormData();
            formData.append("file", values.file);

            try {
                const response = await AxiosConfig.post(`/admin/activites/types/${row.original.actId}/logo`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                if (response.data.success) {
                    handleSuccess("Logo enregistré avec succès");
                    setImage(row.original.actId, response.data.rez.actLogo);
                } else {
                    handleError("Logo non enregistré suite à une erreur.");
                }
                resetForm();
            } catch (error) {
                console.error("Erreur lors de l'upload du fichier", error);
            }
        } else {
            setErrors({file: "Un fichier est requis"});
        }

        setSubmitting(false);
    };

    const columns = [
        /*
        {
            Header: 'Id',
            accessor: 'actId',
            Cell: renderCellId,
        },
        */
        {
            Header: 'Label',
            accessor: 'actLabel',
            Cell: renderCellLabel,
        },
        {
            Header: 'Description',
            accessor: 'actDescription',
            Cell: renderCellDescription,
        },
        {
            Header: 'Police/Fond',
            accessor: 'actColorFont',
            Cell: renderCellColors,
        },
        {
            Header: 'Logo',
            accessor: 'actLogo',
            Cell: (props) => <RenderCellLogo {...props} handleSubmitLogo={handleSubmitLogo} />,
        },
        {
            Header: 'Actif',
            accessor: 'actActif',
            isBoolean: true,
            Cell: (props) => <RenderCellActif {...props} putActifOpenModal={putActifOpenModal} />,
        },
        {
            Header: 'Actions',
            id: 'actions',
            Cell: renderCellActions,
        },
    ];

    return (
        <ReactTableBase dataSource={activiteTypes} columnsData={columns} />
    );
}

export default ActiviteTypeTable;